import React from 'react';
import { Link } from 'react-router-dom';

import { ASSETS_TYPES, LOANS_STATUS } from '../../../constants';
import { ASSET_TOKEN_STATUS, TRANSACTION_TYPE } from '../../../types';
import currencyFormat from '../../../utils/currencyFormat';
import {
  getAssetTokenStatusBadge,
  getTransactionsHistoryBadge,
} from '../../../utils/getStatusBadge';

import './assets-details-top.scss';

interface AssetsDetailsTopProps {
  title: string;
  desc: string;
  sum?: number;
  status?: ASSET_TOKEN_STATUS | LOANS_STATUS;
  type?: ASSETS_TYPES | TRANSACTION_TYPE;
  link?: string;
  linkTitle?: string;
  isHistory?: boolean;
  isInitiator?: boolean;
}

const AssetsDetailsTop: React.FC<AssetsDetailsTopProps> = ({
  title,
  linkTitle,
  sum,
  status,
  link,
  desc,
  type,
  isHistory,
  isInitiator,
}) => (
  <>
    <div className="assets-details__top">
      <h2 className="text-2 assets-details__title">{title}</h2>
      {link && linkTitle && (
        <Link to={link} className="text-3 link link--no-border link--blue">
          {linkTitle}
        </Link>
      )}
    </div>
    <div className="assets-details__info">
      <p className="title-4">
        {desc}{' '}
        {sum ? (
          <>
            <br />
            {currencyFormat(sum)}
          </>
        ) : null}
      </p>
    </div>
    {status && (
      <div className="assets-details__status">
        {isHistory
          ? getTransactionsHistoryBadge(
              status,
              type as TRANSACTION_TYPE,
              isInitiator || false
            )
          : getAssetTokenStatusBadge(status, type as ASSETS_TYPES)}
      </div>
    )}
  </>
);

export default AssetsDetailsTop;
